import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserError, getUserStatus } from '../store/slices/userSlice'
import $ from 'jquery'
import 'datatables.net'
import Modal from 'react-modal'
import { getAllPosts, deletePost } from '../store/featureActions'
import ImageViewer from 'react-simple-image-viewer'
import moment from 'moment'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '0px',
        padding: '0px',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
}

const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '0px',
        padding: '0px',
    },
}

Modal.setAppElement('#root')

const Posts = () => {
    const dispatch = useDispatch()
    const status = useSelector(getUserStatus)
    const error = useSelector(getUserError)
    const [postList, setPostList] = useState(null)
    const [detail, setDetail] = useState(null)
    const [deleteId, setDeleteId] = useState(null)
    const [detailModalOpen, setDetailModalOpen] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [modalImages, setModalImages] = useState(false)
    const [currentImage, setCurrentImage] = useState(0)

    const openImageViewer = useCallback((images, index) => {
        setCurrentImage(index)
        setModalImages(images)
    }, [])

    const closeImageViewer = () => {
        setModalImages(false)
        setCurrentImage(0)
    }

    const openDetailModal = (item) => {
        setDetail(item)
        setDetailModalOpen(true)
    }

    const openDeleteModal = (id) => {
        setDeleteId(id)
        setDeleteModalOpen(true)
    }

    const closeModals = () => {
        setDetailModalOpen(false)
        setDeleteModalOpen(false)
        setDetail(null)
        setDeleteId(null)
    }

    const fetchPosts = async () => {
        try {
            setPostList(null)
            const response = await dispatch(getAllPosts({ params: false, isToast: false })).unwrap()
            setPostList(response?.data?.posts)
        } catch (err) {
            console.log(err)
        }
    }

    const handleDeletePost = async () => {
        try {
            await dispatch(deletePost({ params: deleteId, isToast: true })).unwrap()
            setDeleteModalOpen(false)
            setDeleteId(null)
            $('#postsTable').DataTable().destroy()
            fetchPosts()
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        let mount = true
        if (mount) {
            fetchPosts()
        }
        return () => { mount = false }
    }, [])

    useEffect(() => {
        if (postList) {
            $('#postsTable').DataTable({
                lengthMenu: [10, 25, 50, 100, 200],
                language: { emptyTable: 'No Posts Found' },
                destroy: true,
            })
        }
    }, [postList])

    return (
        <>
            {/* Detail Modal */}
            <Modal
                closeTimeoutMS={500}
                isOpen={detailModalOpen}
                onRequestClose={closeModals}
                style={customStyles}
                contentLabel="Post Detail"
            >
                <div className="change-password-modal" style={{ display: 'block', zIndex: 100 }}>
                    <div className="headerModal">
                        <p className="pass-text">Post Detail</p>
                        <button onClick={closeModals} type="button" className="btn-close" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <p><b>User:</b> {detail?.userName || 'N/A'}</p>
                        <p><b>Game Type:</b> {detail?.type ? detail.type.charAt(0).toUpperCase() + detail.type.slice(1) : 'N/A'}</p>
                        <p><b>Comment:</b> {detail?.comment || 'No comment'}</p>
                        <p><b>Season:</b> {detail?.seasonName || 'N/A'}</p>
                        <p><b>Date:</b> {detail?.createdAt ? moment(detail.createdAt).format('MMM DD, YYYY') : 'N/A'}</p>
                        <div>
                            <b>Image:</b>
                            {detail?.images?.length > 0 ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
                                    {detail.images.map((img, idx) => (
                                        <img
                                            key={idx}
                                            src={img}
                                            alt={`post-img-${idx}`}
                                            onClick={() => openImageViewer(detail.images, idx)}
                                            style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 6, cursor: 'pointer' }}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <span style={{ marginLeft: 8 }}>No image</span>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal
                closeTimeoutMS={500}
                isOpen={deleteModalOpen}
                onRequestClose={closeModals}
                style={deleteStyles}
                contentLabel="Delete Post"
            >
                <div className="change-password-modal" style={{ display: 'block', zIndex: 100 }}>
                    <div className="headerModal">
                        <p className="pass-text">Delete Post Confirmation</p>
                        <button onClick={closeModals} type="button" className="btn-close" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="pass-form-wrap" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
                            <div className="login-button mt-2" style={{ width: '40%' }}>
                                <button
                                    type="button"
                                    onClick={handleDeletePost}
                                    style={{ backgroundColor: 'rgba(0, 69, 139,0.8)' }}
                                    className="cta-btn col-reds w-100"
                                >
                                    Delete
                                </button>
                            </div>
                            <div className="login-button mt-2" style={{ width: '40%' }}>
                                <button
                                    type="button"
                                    onClick={closeModals}
                                    style={{ backgroundColor: 'rgba(0, 69, 139,0.8)' }}
                                    className="cta-btn col-reds w-100"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: postList ? '3%' : '12%' }}>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="table-responsive" id="tableready">
                                            <table id="postsTable" className="table table-bordered display" style={{ width: '100%', textAlign: 'center' }}>
                                                <thead>
                                                    {postList ? (
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>User</th>
                                                            <th>Game Type</th>
                                                            <th>Comment</th>
                                                            <th>Image</th>
                                                            <th>Season</th>
                                                            <th>Date</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    ) : <tr></tr>}
                                                </thead>
                                                <tbody>
                                                    {postList?.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>{item?.userName || 'N/A'}</td>
                                                            <td>{item?.type ? item.type.charAt(0).toUpperCase() + item.type.slice(1) : 'N/A'}</td>
                                                            <td>{item?.comment ? (item.comment.length > 40 ? item.comment.substring(0, 40) + '...' : item.comment) : '—'}</td>
                                                            <td>
                                                                {item?.images?.length > 0 ? (
                                                                    <img
                                                                        src={item.images[0]}
                                                                        alt="post"
                                                                        onClick={() => openImageViewer(item.images, 0)}
                                                                        style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                                                                    />
                                                                ) : '—'}
                                                            </td>
                                                            <td>{item?.seasonName || 'N/A'}</td>
                                                            <td>{item?.createdAt ? moment(item.createdAt).format('MMM DD, YYYY') : 'N/A'}</td>
                                                            <td>
                                                                <span className="edit-icon">
                                                                    <span
                                                                        style={{ cursor: 'pointer', fontWeight: 'bold', margin: 10, fontSize: 13 }}
                                                                        onClick={() => openDetailModal(item)}
                                                                    >
                                                                        <i className="fas fa-eye"></i> View
                                                                    </span>
                                                                    <span
                                                                        style={{ cursor: 'pointer', fontWeight: 'bold', margin: 10 }}
                                                                        onClick={() => openDeleteModal(item._id)}
                                                                    >
                                                                        <i className="fas fa-trash-alt"></i> Delete
                                                                    </span>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                {!postList ?
                                                    status === 'loading' || error ? (
                                                        <tfoot>
                                                            <tr><th>{status === 'loading' ? 'Loading...' : error || ''}</th></tr>
                                                        </tfoot>
                                                    ) : <></> : <></>}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {modalImages && (
                <ImageViewer
                    src={modalImages}
                    currentIndex={currentImage}
                    onClose={closeImageViewer}
                    disableScroll={true}
                    backgroundStyle={{ backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 3 }}
                    closeOnClickOutside={true}
                    showPrevButton={currentImage > 0}
                />
            )}
        </>
    )
}

export default Posts
